export enum taxTabsDisplay {
    taxTabsDisplay = 'tabs'
}

